'use strict';

/*eslint-disable */
var web2print = web2print || {};
var exports = exports || {};
/*eslint-enable */

web2print.env = {
  landingPageUrl: 'https://portal.postnord.com',
  recipientsBaseUrl: 'https://portal.postnord.com/api/web2print/recipients/',
  recipientsBaseUrlV2: 'https://portal.postnord.com/api/web2print/recipients/v2/',
  ordersBaseUrl: 'https://portal.postnord.com/api/web2print/orders/',
  odrBaseUrl: 'https://portal.postnord.com/api/web2print/odr/',
  pricingBaseUrl: 'https://portal.postnord.com/api/web2print/pricing/',
  pdfpreprocessBaseUrl: 'https://portal.postnord.com/api/web2print/pdf/',
  validCustomerNumbersUrl: 'https://portal.postnord.com/api/web2print/orders/customers',
  epncm: 'https://portal.postnord.com/api/customermaster/epncm/',
  translationsPrefix: 'https://portal.postnord.com/translations/',
  ncpDirectmailUrl: 'https://portal.postnord.com/skapa-utskick/#/recipients',
  publicDirectmailUrl: 'https://portal.postnord.com/skapa-utskick/#/recipients',
  usersPublicUrl: 'https://portal.postnord.com/api/ums/v1/me',
  siteV2Url: 'https://portal.postnord.com/skapa-utskick/v2/',
  invoiceForNCP: true,
  humanyWidget: 'w2p-list',
  humanyFloatingWidgetPrefix: 'w2p-floating-',
  enableFeatureToggle: true,
  enabledFeatures: {
    materialDownloadLink: false,
    odrEnabled: true,
    odr: true,
  },
  gtmId: 'GTM-MKQSVP',
  stage: 'prod',
  defaultCountry: 'SE',
  baseUrls: {
    se: 'https://portal.postnord.com/skapa-utskick'
  },
  topBarUrls: {
    se: 'https://portal.postnord.com/pntopbar/directmail'
  },
  createAccount: 'https://portal.postnord.com/createaccount',
  swecoSearchBaseUrl: 'https://web2print-prod.pgm.postnord.com/',
  swecoSearchToken: 'YBHoIrTevGTucR26Y2TXvgAXH9D4XPKg',
  tilesBaseUrl: 'https://tiles-prod.pgm.postnord.com/',
  sideMenuUrl: 'https://portal.postnord.com/portalmenu/menu.js',
  onboardingPageUrl: 'https://portal.postnord.com/createaccount/company/pro',
  addressValidationSocketUrl: 'wss://3cuowpla3h.execute-api.eu-west-1.amazonaws.com/prod',
  serviceAuthorityIDs: ['3', '410']
};

exports.env = {
  topBarUrls: web2print.env.topBarUrls,
  gtmId: web2print.env.gtmId,
  sideMenuUrl: web2print.env.sideMenuUrl
};
